<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">404 Error! Page Not Found.</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/error" class="h5 text-white">The page you're looking for might have been moved, deleted, or never existed.</a>
        </div>
    </div>
</div>

